/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { SagaIterator } from 'redux-saga';
import { call, fork, put } from 'redux-saga/effects';
import {
  OptionUtils,
  Ducks,
  ActionsEventActionNames,
  FolderPurchaseOption,
  FolderType,
  NumberUtils,
} from '@wit/vtv-x-foundation-lib';
import { ActionCreators as EntitlementActionCreators } from 'core/store/ducks/entitlements/index';
import { addRentActionEvent } from '../analytics/actionsEvent';
import { checkIsRental } from '../../../core/store/ducks/pi/options/folderPurchasesOptions';

export default function* run(option: FolderPurchaseOption): SagaIterator {
  if (OptionUtils.isFolderPurchaseOption(option)) {
    const { productPrice, ppvModule, asset } = option;
    const productId = NumberUtils.parse(productPrice.productId);
    if (productId !== undefined) {
      const error = yield call(Ducks.Transactions.purchase, productId, productPrice);
      if (!error) {
        yield put(EntitlementActionCreators.refresh());
      }

      let actionName = ActionsEventActionNames.SUBSCRIBE_PACK;
      if (asset.folderType === FolderType.BUNDLE) {
        const isRental = ppvModule && checkIsRental(ppvModule.fullLifeCycle);
        actionName =
          isRental || !ppvModule ? ActionsEventActionNames.RENT_COLLECTION : ActionsEventActionNames.OWN_COLLECTION;
      }
      yield fork(
        addRentActionEvent,
        actionName,
        asset,
        productPrice,
        actionName === ActionsEventActionNames.OWN_COLLECTION,
        error
      );
      if (error) {
        throw error;
      }
    }
  }
}
